var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C9.60449 4 10.5 3.10456 10.5 2C10.5 0.895437 9.60449 0 8.5 0C7.39551 0 6.5 0.895437 6.5 2C6.5 3.10456 7.39551 4 8.5 4Z",
    fill: "#6B6C7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.98438C10.5 9.08894 9.60449 9.98438 8.5 9.98438C7.39551 9.98438 6.5 9.08894 6.5 7.98438C6.5 6.87981 7.39551 5.98438 8.5 5.98438C9.60449 5.98438 10.5 6.87981 10.5 7.98438Z",
    fill: "#6B6C7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14C10.5 15.1046 9.60449 16 8.5 16C7.39551 16 6.5 15.1046 6.5 14C6.5 12.8954 7.39551 12 8.5 12C9.60449 12 10.5 12.8954 10.5 14Z",
    fill: "#6B6C7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.37139afd764f7d3d3158c90ca079b2a4.svg";
export { ForwardRef as ReactComponent };